import { CouponLimitPerOrder, StoreCouponLimitType } from "../../types/enums";
import { IDataCoupon } from "../../models/data.interface";
import { IOrderCoupon } from "../../models/order.interface";

// Setting 207's one-coupon-per-order rule for online orders. OLO2 mirrors these in its own coupon-limit.ts.
export const isOverride207Coupon = (catalog: IDataCoupon[], couponId: number): boolean =>
    catalog.find(c => c.CouponId === couponId)?.LimitsPerOrder === CouponLimitPerOrder.OVERRIDE_207;

/** True when Setting 207 doesn't limit online coupons, or the incoming coupon is an Override-207 one. */
export const isExemptFromOnlineCouponLimit = (couponLimit: number, catalog: IDataCoupon[], couponId: number | null): boolean =>
    (couponLimit !== StoreCouponLimitType.ONLINE_ONLY && couponLimit !== StoreCouponLimitType.BOTH)
    || (couponId !== null && isOverride207Coupon(catalog, couponId));

/** True when the order already holds a coupon that counts towards Setting 207; Override-207 coupons don't. */
export const hasCouponCountedByLimit = (catalog: IDataCoupon[], orderCoupons: IOrderCoupon[]): boolean =>
    orderCoupons.some(x => !isOverride207Coupon(catalog, x.CouponId));
